import { render, staticRenderFns } from "./MyReviewTable.vue?vue&type=template&id=3f63db4b"
import script from "./MyReviewTable.vue?vue&type=script&lang=js"
export * from "./MyReviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports